import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { DndModule } from 'ng2-dnd';

import { SharedModule } from 'OpsCenter/shared/shared.module';
import { MerchantCategoriesService } from 'OpsCenter/merchants/merchant-categories.service';
import { SeoListComponent } from './seo.list.component';
import { SeoEditComponent } from './seo.edit.component';
import { SeoService } from './seo.service';
import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [SeoListComponent, SeoEditComponent],
  imports: [HttpClientModule, CommonModule, NgbTypeaheadModule, ReactiveFormsModule, SharedModule, DndModule.forRoot()],
  providers: [SeoService, MerchantCategoriesService],
  entryComponents: [SeoListComponent, SeoEditComponent],
})
export class SeoModule {}



// WEBPACK FOOTER //
// ./src/app/seo/seo.module.ts